import React from 'react';
import { Button } from 'primereact/button';
import { usePermissions } from '../../hooks/usePermissions';

const PermissionButton = ({ permission, permissions, role, roles, module, action = 'view', requireAll = false, hideIfNoAccess = false, disableIfNoAccess = true, fallbackComponent = null, children, ...buttonProps }) => {
    const { checkAccess } = usePermissions();

    const hasAccess = checkAccess({
        permission,
        permissions,
        role,
        roles,
        module,
        action,
        requireAll
    });

    // If no access and should hide, return fallback or nothing
    if (!hasAccess && hideIfNoAccess) {
        return fallbackComponent || null;
    }

    // If no access and should disable, disable the button
    if (!hasAccess && disableIfNoAccess) {
        return (
            <Button {...buttonProps} disabled={true} className={`${buttonProps.className || ''} opacity-50 cursor-not-allowed`}>
                {children}
            </Button>
        );
    }

    // Normal button with access
    return <Button {...buttonProps}>{children}</Button>;
};

// Predefined buttons for common actions
export const CreateButton = ({ module, ...props }) => <PermissionButton module={module} action="create" icon="pi pi-plus" outlined {...props} />;

export const EditButton = ({ module, ...props }) => <PermissionButton module={module} action="update" icon="pi pi-pencil" outlined severity="success" {...props} />;

export const DeleteButton = ({ module, ...props }) => <PermissionButton module={module} action="delete" icon="pi pi-trash" outlined severity="danger" {...props} />;

export const ViewButton = ({ module, ...props }) => <PermissionButton module={module} action="view" icon="pi pi-eye" outlined severity="info" {...props} />;

export const StartButton = ({ module, ...props }) => <PermissionButton module={module} action="start" icon="pi pi-play" severity="warning" {...props} />;

export const EndButton = ({ module, ...props }) => <PermissionButton module={module} action="end" icon="pi pi-stop" severity="success" {...props} />;

export const PdfButton = ({ module, ...props }) => <PermissionButton module={module} action="pdf" icon="pi pi-file-pdf" outlined severity="info" {...props} />;

export default PermissionButton;
